module.exports = __webpack_public_path__ + "img/about_top.12cdf391.png";